export default "__VITE_ASSET__B4dqK4R5__"